/* eslint-disable  jsx-a11y/click-events-have-key-events */
/* eslint-disable  jsx-a11y/no-noninteractive-element-interactions */
import { FC, useEffect, useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Tooltip from '@material-ui/core/Tooltip';
import Avatar from '@material-ui/core/Avatar';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@ui/Typography';
import PersonIcon from '@material-ui/icons/Person';
import EditIcon from '@material-ui/icons/Edit';
import {
    chatAnswerChildrenWrapperStyle,
    chatAnswerAvatarStyle,
    chatAnswerDeleteButtonStyle,
    chatAnswerListItemAvatarStyle,
    chatAnswerWrapperStyle,
    chatAnswerTextWrapperStyle,
    chatAnswerTextWrapperWithImageStyle,
    chatAnswerListItemTextPrimaryStyle,
    chatAnswerNameStyle,
    chatAnswerListItemTextStyle,
    chatAnswerEditIconStyle,
} from './styles';
import IChatAnswerProperties from './types';
import { useUserState } from '../../context/UserContext';
import { IUserKey } from '../../../interfaces/User';

const ChatAnswer: FC<IChatAnswerProperties> = ({
    children,
    contentSource,
    onDelete,
}) => {
    const intl = useIntl();
    const { user } = useUserState();
    const [mimeType, setMimeType] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (contentSource) {
            (async () => {
                const { type } = await fetch(contentSource).then((r) => r.blob());
                setMimeType(type);
            })();
        }
    }, [setMimeType, contentSource]);

    return (
        <ListItem component="div" style={chatAnswerWrapperStyle}>
            <ListItemText
                disableTypography
                style={chatAnswerListItemTextStyle}
                primary={(
                    <Typography
                        variant="caption"
                        variantMapping={{ caption: 'span' }}
                        style={chatAnswerNameStyle}
                    >
                        {user && user[IUserKey.FirstName] ? user[IUserKey.FirstName] : <FormattedMessage id="userAvatar" tagName="span" />}
                    </Typography>
                )}
                secondary={(
                    <div style={chatAnswerListItemTextPrimaryStyle}>
                        <Tooltip
                            title={intl.formatMessage({ id: 'edit' })}
                            placement="left"
                            disableFocusListener={!onDelete}
                            disableHoverListener={!onDelete}
                            disableTouchListener={!onDelete}
                        >
                            <Typography
                                onClick={onDelete}
                                variant="subtitle2"
                                variantMapping={{ subtitle2: 'p' }}
                                style={contentSource ? chatAnswerTextWrapperWithImageStyle : chatAnswerTextWrapperStyle}
                            >
                                <span style={chatAnswerChildrenWrapperStyle}>
                                    {children}
                                </span>

                                {onDelete && (
                                    <IconButton size="small" onClick={onDelete} style={chatAnswerDeleteButtonStyle}>
                                        <EditIcon fontSize="small" style={chatAnswerEditIconStyle} />
                                    </IconButton>
                                )}
                            </Typography>
                        </Tooltip>

                        {contentSource && mimeType && (
                            <Tooltip title={intl.formatMessage({ id: 'edit' })} placement="left">
                                <embed
                                    src={contentSource}
                                    style={chatAnswerAvatarStyle}
                                    title="choice"
                                    onClick={onDelete}
                                    type={mimeType}
                                />
                            </Tooltip>
                        )}
                    </div>
                )}
            />

            <ListItemAvatar style={chatAnswerListItemAvatarStyle}>
                <Badge
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    color="secondary"
                    overlap="circular"
                    badgeContent=" "
                    variant="dot"
                >
                    <Avatar>
                        <PersonIcon />
                    </Avatar>
                </Badge>
            </ListItemAvatar>
        </ListItem>
    );
};

export default ChatAnswer;
